import {
  EcommercePerformanceReportOrdersLastYearAction,
  LOAD_ECOMMERCE_PERFORMANCE_REPORT_ORDERS_LAST_YEAR,
  LOAD_ECOMMERCE_PERFORMANCE_REPORT_ORDERS_LAST_YEAR_FAIL,
  LOAD_ECOMMERCE_PERFORMANCE_REPORT_ORDERS_LAST_YEAR_SUCCESS,
  LoadEcommercePerformanceReportOrdersLastYear,
  LoadEcommercePerformanceReportOrdersLastYearFail,
  LoadEcommercePerformanceReportOrdersLastYearSuccess
} from "../actions";

export interface IEcommercePerformanceReportOrdersLastYearEntityState {
  ordersDataLastYear: any;
  loading: boolean;
  loaded: boolean;
}

export interface IEcommercePerformanceReportOrdersLastYearState {
  entities: { [websiteId: number]: IEcommercePerformanceReportOrdersLastYearEntityState };
  loading: boolean;
  loaded: boolean;
}

export const initialState: IEcommercePerformanceReportOrdersLastYearState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IEcommercePerformanceReportOrdersLastYearState = initialState, action: EcommercePerformanceReportOrdersLastYearAction): IEcommercePerformanceReportOrdersLastYearState {
  let payload: any;

  switch (action.type) {

    case  LOAD_ECOMMERCE_PERFORMANCE_REPORT_ORDERS_LAST_YEAR:
      payload = (<LoadEcommercePerformanceReportOrdersLastYear>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_ECOMMERCE_PERFORMANCE_REPORT_ORDERS_LAST_YEAR_SUCCESS:
      payload = (<LoadEcommercePerformanceReportOrdersLastYearSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            ordersDataLastYear: payload.ordersDataLastYear,
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_PERFORMANCE_REPORT_ORDERS_LAST_YEAR_FAIL:
      payload = (<LoadEcommercePerformanceReportOrdersLastYearFail>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };
  }

  return state;
}
